import { IFormValues } from '../../popups/GoalModal/form/types';

const createValues: IFormValues = {
  date: '',
  reason: '',
  reasonHtml: '',
};

export default createValues;
